/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import validate from 'validate.js';
import { makeStyles } from '@material-ui/styles';
import { Grid } from '@material-ui/core';
import * as actionsOlerite from '../../store/olerite/actions';
import * as selectorsOlerite from '../../store/olerite/reducer';
import * as selectorsAuth from '../../store/auth/reducer';
import { Input, DialogDefault, DatePicker, Dropzone, UsuarioSelect, DefaultSelect, YearMonthPicker } from '../../components';
import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';

const createSchema = {
  tipo: { presence: { allowEmpty: false, message: 'é obrigatório' } },
  mesReferencia: { presence: { allowEmpty: false, message: 'é obrigatório' } },
  usuarioId: { presence: { allowEmpty: false, message: 'é obrigatório' } },
  file: { presence: { allowEmpty: false, message: 'é obrigatório' } },
};

const useStyles = makeStyles(() => ({
  gridContainer: {
    marginTop: 0
  },
  fieldContainer: {
    paddingBottom: '0px !important'
  }
}));

const FormularioEdicao = ({
  updateOlerite,
  findOleriteById,
  oleriteClearSelected,
  selectedOlerite,
  open,
  id,
  onClose,
  authData,
  adminPermission,
}) => {
  const classes = useStyles();

  const [values, setValues] = useState({});
  const [errors, setErrors] = useState({});

  const getDefaultValues = () => ({
    criadoPorId: authData.id,
    criadoPorNome: authData.nome,
    mesReferencia: moment().format('YYYY-MM'),
    arquivos: [],
  });

  useEffect(() => {
    if (open && !id) {
      setValues(getDefaultValues());
    }
  }, [id, open]);

  useEffect(() => {
    if (id) {
      findOleriteById(id);
    }
  }, [id, findOleriteById]);

  useEffect(() => {
    if (selectedOlerite && selectedOlerite.id) {
      setValues({
        ...selectedOlerite,
        mesReferencia: selectedOlerite.mesReferencia || moment().format('YYYY-MM'),
      });
    }
  }, [selectedOlerite]);

  const onSave = () => {
    var erros = validate(values, createSchema)
    setErrors(erros || {});
    if (!erros) {
      updateOlerite(values.id, values, saveCallback);
    }
  };

  const saveCallback = (success) => {
    if (success) {
      onCloseLocal(true);
    }
  };

  const onCloseLocal = (isSave) => {
    oleriteClearSelected();
    setErrors({});
    setValues(getDefaultValues());
    onClose(isSave);
  };

  return (
    <DialogDefault
      open={open}
      handlerCancel={() => onCloseLocal(false)}
      handlerConfirm={onSave}
      title="Holerite"
      confirmMessage="Salvar"
      contentClassName={classes.contentClassName}
      maxWidth="md"
    >
      <Grid container spacing={3} className={classes.gridContainer}>
        <Grid item xs={4} className={classes.fieldContainer}>
          <DefaultSelect
            label="Tipo"
            name="tipo"
            isRequired
            error={errors && errors.tipo}
            options={[
              { id: 'HOLERITE', nome: 'Holerite' }, 
              { id: 'INFORME_RENDIMENTO', nome: 'Informe de Rendimento' }
            ]}
            onSelect={e => setValues({ ...values, tipo: e.target.value || null })}
            value={values.tipo}
          />
        </Grid>
        <Grid item xs={4} className={classes.fieldContainer}>
          <YearMonthPicker
            label={values.tipo === 'HOLERITE' ? 'Mês Referência' : 'Ano de Referência'}
            value={values.mesReferencia}
            onChange={(val) => setValues({ ...values, mesReferencia: val })}
            error={errors?.mesReferencia}
            isRequired
            onlyYear={values.tipo === 'INFORME_RENDIMENTO'}
            disabled={!adminPermission}
          />
        </Grid>
        <Grid item xs={4} className={classes.fieldContainer}>
          <Input
            label="Criado Por"
            value={values.criadoPorNome}
            disabled
          />
        </Grid>
        <Grid item xs={4} className={classes.fieldContainer}>
          <Input
            label="Data Criação"
            value={values.dataInclusaoValue}
            disabled
          />
        </Grid>
        <Grid item xs={8} className={classes.fieldContainer}>
          <UsuarioSelect
            label="Usuário"
            onSelect={usuarioId => setValues({ ...values, usuarioId })}
            ativo
            value={values.usuarioId}
            isRequired
            error={errors && errors.usuarioId}
            multiSelect={false}
            disabled={!adminPermission}
          />
        </Grid>
        <Grid item xs={12} className={classes.fieldContainer}>
          <Dropzone 
            buttonText="Arquivo"
            filesLimit={1}
            acceptedFiles={['.png', '.pdf', '.jpeg', '.jpg']}
            showGridFiles
            canDeleteFiles
            disabled={!adminPermission}
            buttonClassName={classes.buttonContainer}
            error={errors && errors.file}
            onSave={files => {
              if (files != null && files.length > 0) {
                var file = files[0];
                var fileOptions = {
                  id: uuidv4(),
                  nome: file.name.split('.')[0],
                  extensao: file.name.split('.').pop(),
                  alt: file.name,
                  file,
                  new: true,
                }
                setValues({ ...values, file: fileOptions });
              } else {
                setValues({ ...values, file: null });
              }
            }}
            files={values.file != null ? [{
              file: values.file.file,
              nome: values.file.alt,
              onDelete: () => {
                setValues({ ...values, file: null });
              }
            }] : []}
          />
        </Grid>
      </Grid>
    </DialogDefault>
  );
};

const mapStateToProps = (state) => ({
  selectedOlerite: selectorsOlerite.getSelectedOlerite(state),
  authData: selectorsAuth.getAuth(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ...actionsOlerite,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(FormularioEdicao);
